import classNames from "classnames";
import React, { HTMLAttributes, useCallback } from "react";
import { markEventBlocked } from "./ViewTable.lib";
import styles from "./ViewTableCell.module.scss";

interface Props extends HTMLAttributes<HTMLDivElement> {
    captureClicks?: boolean;
}

export const ViewTableCell = React.memo(
    ({ children, className, onClick, captureClicks, ...props }: Props) => {
        const handleClick = useCallback(
            (e: React.MouseEvent<HTMLDivElement>) => {
                if (!e || !captureClicks) {
                    return;
                }
                markEventBlocked(e);

                onClick?.(e);
            },
            [onClick, captureClicks],
        );

        return (
            <div
                className={classNames(styles.viewTableCell, className)}
                onClick={handleClick}
                {...props}
            >
                {children}
            </div>
        );
    },
);
ViewTableCell.displayName = "ViewTableCell";
